import axios from 'axios'
import api from '@/services/api'

export default {
    async fetchList () {
      return await axios.get(api.baseUrl + 'grouphead' )
    },
    async fetchHead() {
        try {
            var head = await axios.get(api.baseUrl + 'head')
            head = await head.data
            return head
        } catch(err) {
            console.log(err)
        }
        //return await axios.get(api.baseUrl + 'head').json
    }
}